/**
 * Format usernames that are emails by keeping everything before the @ sign.
 * @param {string} name - Username
 * @return {string}
 */
// eslint-disable-next-line import/prefer-default-export
export const formatUsername = (name) => name?.split('@')[0];
